import { useEffect, useState } from "react";
import i18n, { langs } from "../locals/i18n.ts";
import styles from "../styles/DropdownLang.module.css"
const DropdownLang = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(langs.find((l) => l.value === 'es')!);

  useEffect(() => {
    if (window.localStorage.getItem("lang")) {
      i18n.changeLanguage(window.localStorage.getItem("lang")!);
      setCurrentLang(langs.find((l) => l.value === window.localStorage.getItem("lang"))!);
    }
  }, [])

  const changeLang = (lang: string) => {
    window.localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    setIsOpen(false);
    setCurrentLang(langs.find((l) => l.value === lang)!);
  };

  return (
    <div className={styles.relative}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={styles.langbutton}
      >
        <img className={styles.buttonImg} src={currentLang.icon} alt="" />
        <span>{currentLang.label}</span>
      </div>
      {isOpen && (
        <div className={styles.menu}>
          <ul className={styles.menuList}>
            {langs.map((lang) => (
              <li
                key={lang.value}
                onClick={() => changeLang(lang.value)}
                className={styles.menuItem}
              >
                <img className={styles.menuItemImg} src={lang.icon} alt="" />
                <span className={styles.menuItemLabel}>{lang.label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DropdownLang;